export const getPageDirectionFromLocale = (locale: string): 'ltr' | 'rtl' => {
  const rtlLanguages = ['ur-PK'];

  return rtlLanguages.includes(locale) ? 'rtl' : 'ltr';
};
